import { scrollToElement } from "./scroll-to-element";

export default function ScrollToNav() {
  const wrapper = document.querySelectorAll<HTMLDivElement>(".js-scroll-to-nav");
  const mobileWrapper = document.querySelectorAll<HTMLDivElement>(".js-scroll-to-mobile-nav");
  const floatingContentBlock = document.querySelectorAll<HTMLDivElement>(".js-floating-content[data-banner=true]");

  if (wrapper) {
    wrapper.forEach((item) => {
      const scrollToBtns = item.querySelectorAll<HTMLButtonElement>(".js-scroll-to-btn");

      const handleScrollTo = (id: string) => {
        if (id) {
          scrollToElement(id, { smooth: true });
        }
      };

      const handleStickyTop = () => {
        setTimeout(() => {
          const header = document.querySelector("header");
          const headerHeight = header ? header.offsetHeight : 0;

          item.style.top = `${headerHeight}px`;
        }, 0);
      };

      const handleSectionOffset = () => {
        const stickyHeaderHeight = document.querySelector("header")?.offsetHeight || 0;

        return stickyHeaderHeight;
      };

      const handleActiveSection = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let startOffset = 0;

        if (scrollToBtns && scrollToBtns.length > 0) {
          scrollToBtns.forEach((btn, index) => {
            const scrollId = btn.getAttribute("data-id");
            if (scrollId) {
              const section = document.getElementById(scrollId);

              if (section) {
                const sectionTopOffset = section.offsetTop - handleSectionOffset() - 5; // trigger 5 pixels early
                const sectionBottomOffset = section.offsetTop + section.offsetHeight - handleSectionOffset() - 5; // add 5 pixel buffer

                // define above the fold amount based on the top of the first item
                if (index === 0) {
                  startOffset = sectionTopOffset;
                }

                // set each section to active if you're in view of the section
                // else set first item active if scroll top is above the fold
                if (scrollTop >= sectionTopOffset && scrollTop < sectionBottomOffset) {
                  btn.setAttribute("data-active", "true");
                } else if (scrollTop < startOffset && index === 0) {
                  btn.setAttribute("data-active", "true");
                } else {
                  btn.setAttribute("data-active", "false");
                }
              }
            }
          });
        }
      };

      if (scrollToBtns && scrollToBtns.length > 0) {
        handleStickyTop();
        handleActiveSection();
        window.addEventListener("scroll", handleActiveSection);
        window.addEventListener("resize", handleStickyTop);

        scrollToBtns.forEach((btn) => {
          const scrollId = btn.getAttribute("data-id");
          if (scrollId) {
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              handleScrollTo(scrollId);
            });
          }
        });

        // if there is floating content then adjust the top position on close
        if (floatingContentBlock && floatingContentBlock.length > 0) {
          floatingContentBlock.forEach((item) => {
            const closeBtn = item.querySelector(".js-close-btn");
            // adjust top nav bar position when floating content closes
            closeBtn?.addEventListener("click", handleStickyTop);
          });
        }
      }
    });
  }

  if (mobileWrapper) {
    mobileWrapper.forEach((item) => {
      const scrollToBtns = item.querySelectorAll<HTMLButtonElement>(".js-scroll-to-btn");
      const scrollToMenuBtn = item.querySelector<HTMLButtonElement>(".js-scroll-to-menu-btn");
      let isOpen = false;

      const handleToggleMenu = () => {
        console.log("handle toggle menu");
        isOpen = !isOpen;

        item.setAttribute("data-open", isOpen.toString());
        console.log("set is open ", isOpen);
      };

      const handleScrollTo = (id: string) => {
        if (id) {
          handleToggleMenu();
          scrollToElement(id, { smooth: true });
        }
      };

      if (scrollToMenuBtn) {
        scrollToMenuBtn.addEventListener("click", handleToggleMenu);
      }

      if (scrollToBtns && scrollToBtns.length > 0) {
        scrollToBtns.forEach((btn) => {
          const scrollId = btn.getAttribute("data-id");
          if (scrollId) {
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              handleScrollTo(scrollId);
            });
          }
        });
      }
    });
  }
}
